import Loadable from 'react-loadable';

import { FooterTheme } from '@rover/kibble/styles';
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import retry from '@rover/rsdk/src/modules/Network/retry';
import Route from '@rover/types/src/Route';

import Loading from '../client/Loading';

const PaymentCompletionPage = Loadable({
  loader: () =>
    retry(
      () =>
        import(
          /* webpackChunkName: "PaymentCompletionPage" */ '@rover/pages/src/account/PaymentCompletionPage/PaymentCompletionPage'
        )
    ),
  loading: Loading,
});

const routes: Route[] = [
  {
    path: '/provider-profile/identity-verification/payment-completion/',
    pageName: 'payment-completion',
    component: PaymentCompletionPage,
    componentName: 'PaymentCompletionPage',
    exact: true,
    requiresAuth: true,
  },
].map((route) => ({
  ...route,
  concept: CONCEPTS.service_offerings.background_checks,
  pageCategory: 'sitter-sign-up',
  navBarIsFullWidth: false,
  footerTheme: FooterTheme.LIGHT,
  cacheTag: ['page-sitter-sign-up', 'page-all'],
  isReactQueryRoute: true,
}));
export default routes;
